//Vuex
import Vue from 'vue'
import Vuex from 'vuex';
import 'es6-promise/auto'
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
      user_token: '',
      user_token_expire: '',
    },
    getters: {
        token: state => {
            return {'token':state.user_token,'expire':state.user_token_expire}
        }
    },
    mutations: {
        token (state,newValue) {
            state.user_token = newValue.token;
            state.user_token_expire = newValue.expire;
            window.axios.defaults.headers.common['Authorization'] = newValue.token;
        }
      },
      actions: {
        token (context) {
          context.commit('token')
        }
      }
  });

export default store